import { ThemeEvents, DiscountUpdateEvent } from "./events.js";

class CartDiscount extends HTMLElement {
  static DEBUG = false;

  static ICON_TAG = `<svg width="16" height="16" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="#50AA6C" fill-rule="evenodd" clip-rule="evenodd" d="M0.6875 2.25C0.6875 1.11091 1.61091 0.1875 2.75 0.1875H13.25C14.3891 0.1875 15.3125 1.11091 15.3125 2.25V4.5C15.3125 4.81066 15.0607 5.0625 14.75 5.0625C14.5092 5.0625 14.2703 5.15392 14.0871 5.33709C13.721 5.7032 13.721 6.2968 14.0871 6.66291C14.2703 6.84608 14.5092 6.9375 14.75 6.9375C15.0607 6.9375 15.3125 7.18934 15.3125 7.5V9.75001C15.3125 10.8891 14.3891 11.8125 13.25 11.8125H2.75C1.61091 11.8125 0.6875 10.8891 0.6875 9.75V7.5C0.6875 7.18934 0.93934 6.9375 1.25 6.9375C1.4908 6.9375 1.72974 6.84608 1.91291 6.66291C2.27903 6.2968 2.27903 5.7032 1.91291 5.33709C1.72974 5.15392 1.4908 5.0625 1.25 5.0625C0.93934 5.0625 0.6875 4.81066 0.6875 4.5V2.25ZM2.75 1.3125C2.23223 1.3125 1.8125 1.73223 1.8125 2.25V4.01543C2.1405 4.10814 2.45037 4.28356 2.70841 4.54159C3.51386 5.34705 3.51386 6.65295 2.70841 7.45841C2.45037 7.71644 2.1405 7.89186 1.8125 7.98457V9.75C1.8125 10.2678 2.23223 10.6875 2.75 10.6875H5.9375V1.3125H2.75ZM7.0625 1.3125V10.6875H13.25C13.7678 10.6875 14.1875 10.2678 14.1875 9.75001V7.98457C13.8595 7.89186 13.5496 7.71644 13.2916 7.45841C12.4861 6.65295 12.4861 5.34705 13.2916 4.54159C13.5496 4.28356 13.8595 4.10814 14.1875 4.01543V2.25C14.1875 1.73223 13.7678 1.3125 13.25 1.3125H7.0625Z" fill="#292929"></path></svg>`;

  static ICON_TRASH = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>`;

  static ICON_SPINNER = `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="32" stroke-dashoffset="32"><animate attributeName="stroke-dashoffset" values="32;0" dur="1s" repeatCount="indefinite"/></circle></svg>`;

  constructor() {
    super();
    // Fonte da verdade é sempre cart.discount_codes vindo do Shopify.
    // localStorage foi removido de propósito: um código remanescente de outro
    // carrinho/sessão fazia o guard de "já aplicado" barrar cupons válidos.
    this.appliedDiscounts = new Set();
    this.notApplicableDiscounts = new Set();
    this.busy = false;
    // Incrementa a cada mutação confirmada; o hydrate usa isso para descartar
    // uma resposta de /cart.js que chegou depois de um aplicar/remover.
    this.generation = 0;
  }

  log(...args) {
    if (CartDiscount.DEBUG) console.log("🛒 [CartDiscount]:", ...args);
  }

  get cartUpdateUrl() {
    return window.routes?.cart_update_url || "/cart/update.js";
  }

  get cartPath() {
    return (window.routes?.cart || "/cart").replace(/\/$/, "");
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.querySelector('[name="discount"]');
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.open = this.querySelector(".insert-code");
    this.openLabel = this.open?.querySelector("span");
    this.error = this.querySelector(".discount-error");
    this.discountsList = this.querySelector(".applied-discounts-list");
    this.removeAllButtons = [...this.querySelectorAll(".remove-discount")];

    this.form?.addEventListener("submit", this.apply);
    this.open?.addEventListener("click", this.toggle);
    this.removeAllButtons.forEach((btn) =>
      btn.addEventListener("click", this.onRemoveAllClick)
    );
    // Delegado: as tags são re-renderizadas, os listeners não precisam ser.
    this.discountsList?.addEventListener("click", this.onListClick);

    // Chave legada envenenada em navegadores que já usaram a versão anterior.
    try {
      localStorage.removeItem("appliedDiscounts");
    } catch (e) {
      /* modo privado / storage bloqueado */
    }

    this.clearDiscountInput();
    this.hydrate();
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.apply);
    this.open?.removeEventListener("click", this.toggle);
    this.removeAllButtons?.forEach((btn) =>
      btn.removeEventListener("click", this.onRemoveAllClick)
    );
    this.discountsList?.removeEventListener("click", this.onListClick);
  }

  /* ---------------------------------------------------------------- estado */

  async hydrate() {
    const gen = this.generation;
    const cart = await this.fetchCart();
    // Se o cliente aplicou um cupom enquanto este GET estava no ar, esta
    // resposta é mais antiga que o estado atual — aplicá-la apagaria a tag.
    if (!cart || gen !== this.generation) return;
    this.setStateFromCart(cart);
    this.renderDiscountsList();
  }

  async fetchCart() {
    try {
      const response = await fetch(`${this.cartPath}.js`, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.error("[CartDiscount] erro ao ler o carrinho:", error);
      return null;
    }
  }

  // cart.discount_codes = [{ code, applicable }]. Códigos com applicable:false
  // continuam no carrinho (ex.: mínimo não atingido) e voltam a valer sozinhos
  // quando o carrinho ficar elegível — por isso ficam visíveis, não descartados.
  setStateFromCart(cart) {
    const codes = Array.isArray(cart?.discount_codes)
      ? cart.discount_codes
      : [];
    this.appliedDiscounts = new Set(
      codes.filter((d) => d.applicable).map((d) => d.code)
    );
    this.notApplicableDiscounts = new Set(
      codes.filter((d) => !d.applicable).map((d) => d.code)
    );
    this.classList.toggle("discount-applied", this.appliedDiscounts.size > 0);
    this.log(
      "estado",
      [...this.appliedDiscounts],
      [...this.notApplicableDiscounts]
    );
  }

  allCodes() {
    return [...this.appliedDiscounts, ...this.notApplicableDiscounts];
  }

  has(code) {
    const needle = code.toLowerCase();
    return [...this.appliedDiscounts].some((c) => c.toLowerCase() === needle);
  }

  // O código vem do carrinho, mas foi digitado pelo cliente e o update.js
  // devolve a string crua — sem escapar, ele é injetado no innerHTML da tag.
  static escapeHtml(value) {
    return String(value).replace(
      /[&<>"']/g,
      (c) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[c]
    );
  }

  /* ------------------------------------------------------------------- rede */

  async postDiscounts(codes) {
    const response = await fetch(this.cartUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: codes.join(",") }),
    });

    const data = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(data?.description || `HTTP ${response.status}`);
    }
    // A resposta do update.js já traz discount_codes: não precisa de /cart.js.
    return data;
  }

  /* --------------------------------------------------------------------- UI */

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
  }

  hideError() {
    if (this.error) this.error.hidden = true;
  }

  clearDiscountInput() {
    if (this.input) this.input.value = "";
  }

  setFormLoading(loading) {
    this.busy = loading;
    if (!this.submitButton) return;
    this.submitButton.disabled = loading;
    const label = this.submitButton.querySelector("span");
    const spinner = this.submitButton.querySelector(".loading-spinner");
    // O spinner é position:absolute e centralizado; esconder o label por
    // visibility mantém a largura do botão estável.
    if (label) label.style.visibility = loading ? "hidden" : "";
    if (spinner) spinner.classList.toggle("hidden", !loading);
  }

  setButtonLoading(el) {
    if (!el) return () => {};
    const original = el.innerHTML;
    const wasDisabled = el.disabled;
    el.disabled = true;
    el.innerHTML = CartDiscount.ICON_SPINNER;
    let done = false;
    return () => {
      if (done) return;
      done = true;
      el.disabled = wasDisabled;
      el.innerHTML = original;
    };
  }

  toggle = (e) => {
    e.preventDefault();
    const isOpen = this.dataset.open === "opened";
    this.dataset.open = isOpen ? "closed" : "opened";

    this.dispatchEvent(
      new CustomEvent(ThemeEvents.discountToggle, {
        bubbles: true,
        detail: { open: !isOpen, sectionId: this.dataset.sectionId },
      })
    );

    this.clearDiscountInput();
    this.hideError();

    // Escreve só no <span>: textContent no botão apagaria o span e o svg.
    const label = this.openLabel || this.open;
    if (label) label.textContent = isOpen ? "Inserir código" : "Fechar";

    if (!isOpen) this.input?.focus();
  };

  renderDiscountsList() {
    if (!this.discountsList) return;

    const codes = this.allCodes();
    if (codes.length === 0) {
      this.discountsList.innerHTML = "";
      this.discountsList.hidden = true;
      return;
    }

    const tags = codes
      .map((code) => {
        const isApplicable = this.has(code);
        const safe = CartDiscount.escapeHtml(code);
        return `
              <div class="discount-tag ${
                !isApplicable ? "discount-tag--not-applicable" : ""
              }">
                <span class="icon-discount-tag">${CartDiscount.ICON_TAG}</span>
                <span class="discount-code">${safe}</span>
                ${
                  !isApplicable
                    ? '<span class="discount-status">Não aplicável</span>'
                    : ""
                }
                <button type="button" class="remove-single-discount" data-discount="${safe}" aria-label="Remover ${safe}">
                  ${CartDiscount.ICON_TRASH}
                </button>
              </div>`;
      })
      .join("");

    this.discountsList.innerHTML = `
      <div class="applied-discounts-container">
        <div class="discount-tags">${tags}</div>
      </div>
    `;
    this.discountsList.hidden = false;
  }

  /* ---------------------------------------------------------------- ações */

  apply = async (e) => {
    e.preventDefault();
    if (this.busy) return;

    const code = (this.input?.value || "").trim();
    if (!code) {
      this.showError("Por favor, insira um código de desconto.");
      return;
    }

    this.setFormLoading(true);

    try {
      // Revalida contra o carrinho antes de julgar "já aplicado": o estado em
      // memória pode estar velho (cupom aplicado por combo/bundle, outra aba,
      // checkout abandonado). Sem isso, cupom válido era barrado sem request.
      const cart = await this.fetchCart();
      if (cart) this.setStateFromCart(cart);

      if (this.has(code)) {
        this.showError("Este código de desconto já foi aplicado.");
        this.renderDiscountsList();
        return;
      }

      // update.js substitui o conjunto inteiro, então os códigos que já valem
      // precisam ser reenviados — senão aplicar um cupom apaga os outros.
      const codes = this.appliedDiscounts.size
        ? [...this.appliedDiscounts].filter(
            (c) => c.toLowerCase() !== code.toLowerCase()
          )
        : [];
      codes.push(code);

      const data = await this.postDiscounts(codes);
      this.generation++;
      this.setStateFromCart(data);
      this.renderDiscountsList();

      // Cupom inválido/não elegível volta HTTP 200 com applicable:false —
      // nunca em data.status. Checar o status era o que engolia o erro.
      if (!this.has(code)) {
        this.showError("Cupom inválido ou não aplicável a este carrinho.");
        return;
      }

      this.hideError();
      this.clearDiscountInput();

      document.dispatchEvent(
        new DiscountUpdateEvent(data, this.dataset.sectionId)
      );
      this.refreshCart(data);
    } catch (error) {
      console.error("[CartDiscount] erro ao aplicar desconto:", error);
      this.showError("Erro ao aplicar desconto. Tente novamente.");
    } finally {
      this.setFormLoading(false);
    }
  };

  onListClick = (e) => {
    const button = e.target.closest(".remove-single-discount");
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    const code = button.dataset.discount;
    if (code) this.removeSingleDiscount(code, button);
  };

  onRemoveAllClick = (e) => {
    e.preventDefault();
    this.clearAllDiscounts(e.currentTarget);
  };

  removeSingleDiscount = (code, buttonElement = null) => {
    const remaining = this.allCodes().filter(
      (c) => c.toLowerCase() !== code.toLowerCase()
    );
    // Um único request: a versão anterior limpava tudo e reaplicava um a um
    // com 300ms de espera entre cada, o que gerava N+2 requests e corrida.
    return this.commit(remaining, buttonElement, "Erro ao remover o cupom.");
  };

  clearAllDiscounts = (buttonElement = null) =>
    this.commit([], buttonElement, "Erro ao remover os cupons.");

  async commit(codes, buttonElement, errorMessage) {
    if (this.busy) return;
    this.busy = true;
    const restore = this.setButtonLoading(buttonElement);

    try {
      const data = await this.postDiscounts(codes);
      this.generation++;
      this.setStateFromCart(data);
      this.renderDiscountsList();
      this.hideError();

      document.dispatchEvent(
        new DiscountUpdateEvent(data, this.dataset.sectionId)
      );
      this.refreshCart(data);
    } catch (error) {
      console.error("[CartDiscount] erro ao atualizar cupons:", error);
      this.showError(errorMessage);
    } finally {
      // Sempre restaura: o botão "Remover todos" fica fora de
      // .applied-discounts-list e não é substituído pelo re-render.
      restore();
      this.busy = false;
    }
  }

  /* ------------------------------------------------------------- refresh */

  isCartPage() {
    return window.location.pathname.replace(/\/$/, "") === this.cartPath;
  }

  // Sem isto o cupom aplicava no Shopify mas o drawer continuava mostrando o
  // total antigo — o cliente lia isso como "o cupom não funcionou".
  refreshCart(cart) {
    if (this.isCartPage()) {
      window.location.reload();
      return;
    }
    // Caminho canônico do tema (theme.js -> /cart?view=ajax_side_cart);
    // re-renderiza totais, linha de desconto e este próprio componente.
    if (typeof window.sharedFunctions?.updateSidebarCart === "function") {
      window.sharedFunctions.updateSidebarCart(cart);
    }
  }
}

customElements.define("cart-discount-component", CartDiscount);

class CartShipping extends HTMLElement {
  fmtBRL(v) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(v) || 0);
  }

  deliveryHtml(range) {
    const _isDateLike = (v) =>
      typeof v === "string" && !Number.isNaN(Date.parse(v));
    const _toDate = (v) => {
      if (v == null) return null;
      if (typeof v === "number" && Number.isFinite(v)) {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + v);
        return d;
      }
      if (_isDateLike(v)) return new Date(v);
      return null;
    };
    const _fmt = (d) =>
      d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
    const _rel = (d) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const cmp = new Date(d);
      cmp.setHours(0, 0, 0, 0);
      const diff = Math.round((cmp - today) / 86400000);
      if (diff === 0) return "Hoje";
      if (diff === 1) return "Amanhã";
      if (diff > 1 && diff <= 7) {
        const wd = cmp.toLocaleDateString("pt-BR", { weekday: "short" });
        return `${wd} (${_fmt(cmp)})`;
      }
      return _fmt(cmp);
    };

    if (!range) return "";
    if (typeof range === "string") return range;

    let min = range.min ?? range.minimum ?? range.from ?? range[0] ?? null;
    let max = range.max ?? range.maximum ?? range.to ?? range[1] ?? null;
    const unit = String(range.unit || range.units || range.type || "");

    if (typeof min === "number" || typeof max === "number") {
      const same = (min ?? max) === (max ?? min);
      const qtd = same ? (min ?? max) : `${min ?? "?"}–${max ?? "?"}`;
      const uteis = unit.includes("business");
      return `em ${qtd} ${uteis ? "dias úteis" : "dias"}`;
    }

    const dMin = _toDate(min),
      dMax = _toDate(max);
    if (dMin && dMax) {
      if (dMin.toDateString() === dMax.toDateString()) return _rel(dMin);
      const diff = Math.max(0, Math.round((dMax - dMin) / 86400000));
      const a = _rel(dMin),
        b = diff <= 14 ? _rel(dMax) : _fmt(dMax);
      return `entre ${a} e ${b}`;
    }
    if (dMin) return `a partir de ${_rel(dMin)}`;
    if (dMax) return `até ${_rel(dMax)}`;
    return "";
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.open = this.querySelector(".insert-cep");
    this.error = this.querySelector(".shipping-component-error");

    if (this.form) this.form.addEventListener("submit", this.apply);
    if (this.open) this.open.addEventListener("click", this.toggle);

    const savedRates = localStorage.getItem("shippingRates");
    const selectedRate = localStorage.getItem("selectedShippingRate");

    if (savedRates && selectedRate) {
      this.renderSelected(JSON.parse(selectedRate));
    } else if (savedRates) {
      // Se há rates salvos mas não há seleção, selecionar automaticamente o mais barato
      const rates = JSON.parse(savedRates);
      rates.sort((a, b) => a.price - b.price);
      const cheapestRate = rates[0];
      localStorage.setItem(
        "selectedShippingRate",
        JSON.stringify(cheapestRate)
      );
      this.renderSelected(cheapestRate);
    }
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener("submit", this.apply);
    this.teardownRefazer();
  }

  toggle = (e) => {
    e.preventDefault();
    const isOpen = this.dataset.open === "opened";
    this.dataset.open = isOpen ? "closed" : "opened";

    if (isOpen) {
      const cepInput = this.form?.querySelector('[name="shipping-component"]');
      if (cepInput) cepInput.value = "";
      this.error.hidden = true;
    }
    this.open.textContent = isOpen ? "Calcule seu frete" : "Fechar";
  };

  apply = async (e) => {
    e.preventDefault();

    const raw =
      this.form.querySelector('[name="shipping-component"]')?.value || "";
    const zip = raw.replace(/\D/g, "");
    if (zip.length !== 8) {
      this.error.textContent = "Informe um CEP válido (8 dígitos).";
      this.error.hidden = false;
      return;
    }

    const spinner = this.form.querySelector(".form-loading");
    spinner.classList.remove("hidden");
    this.error.hidden = true;

    try {
      // Salvar o CEP para recálculos automáticos futuros
      localStorage.setItem("lastCalculatedCep", zip);

      // Executar cálculo usando o método refatorado
      await this.calculateShippingRates(zip);

      // Fechar o formulário após calcular
      this.dataset.open = "closed";
      this.open.textContent = "Calcule seu frete";

      // Recarregar página se estiver na URL /cart após selecionar frete
      if (window.location.pathname === "/cart") {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      this.error.textContent =
        err.message || "Erro ao consultar frete. Tente novamente.";
      this.error.hidden = false;
    } finally {
      spinner.classList.add("hidden");
    }
  };

  // helper de polling (coloque dentro da mesma classe)
  pollRates = async (url, { tries = 12, delay = 500 } = {}) => {
    for (let i = 0; i < tries; i++) {
      const res = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data?.shipping_rates) && data.shipping_rates.length)
          return data.shipping_rates;
      }
      await new Promise((r) => setTimeout(r, delay));
    }
    return [];
  };

  renderList(rates) {
    // Método mantido para compatibilidade, mas agora seleciona automaticamente a opção mais barata
    rates.sort((a, b) => a.price - b.price);
    const cheapestRate = rates[0];
    localStorage.setItem("selectedShippingRate", JSON.stringify(cheapestRate));
    this.renderSelected(cheapestRate);

    // Recarregar página se estiver na URL /cart após selecionar frete
    if (window.location.pathname === "/cart") {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  }

  renderSelected(selected) {
    const listBox = this.querySelector(".selected-shipping-components");
    const wrapper = listBox.querySelector(".shipping-wrapper");
    let resume = listBox.querySelector(".shipping-resume");
    if (!resume) {
      resume = document.createElement("div");
      resume.className = "shipping-resume";
      listBox.appendChild(resume);
    }

    wrapper.style.display = "none";
    listBox.classList.remove("hidden");
    this.classList.add("shipping-component-applied");

    const prazo = this.deliveryHtml(selected.delivery_range);
    resume.innerHTML = `
      <li class="shipping-component-item">
        <span class="shipping-selected-wrapper">
          <!-- ícone omitido -->
          <span>${selected.name} ${prazo ? `(até ${prazo})` : ""}&nbsp;&mdash;&nbsp;</span>
        </span>
        <span>${
          Number(selected.price) === 0 ? "Grátis" : this.fmtBRL(selected.price)
        }</span>
        <button type="button" class="remove-shipping-component" aria-label="Refazer cálculo">Remover</button>
      </li>
    `;

    this.updateShippingListValue(selected.price);
    this.setAttribute("data-open", "closed");
    this.teardownRefazer?.();
    this._refazerBtn = resume.querySelector(".remove-shipping-component");
    this._refazerBtn?.addEventListener("click", this.clearShipping);
  }

  // Emite um evento para atualizar a listagem de preços. Cf. events.js:40
  updateShippingListValue(price, removed = false) {
    document.dispatchEvent(
      new CustomEvent("shipping:update", {
        detail: { price, fmtBRL: this.fmtBRL, removed },
        bubbles: true,
        composed: true,
      })
    );
  }

  teardownRefazer() {
    if (this._refazerBtn) {
      this._refazerBtn.removeEventListener("click", this.clearShipping);
      this._refazerBtn = null;
    }
  }

  clearShipping = () => {
    localStorage.removeItem("shippingRates");
    localStorage.removeItem("selectedShippingRate");
    localStorage.removeItem("lastCalculatedCep"); // Limpar CEP salvo também

    const listBox = this.querySelector(".selected-shipping-components");
    const wrapper = listBox?.querySelector(".shipping-wrapper");
    const resume = listBox?.querySelector(".shipping-resume");

    if (resume) resume.remove(); // remove apenas o resumo
    if (wrapper) wrapper.style.display = ""; // volta a lista pro display padrão
    listBox?.classList.add("hidden");

    this.classList.remove("shipping-component-applied");
    this.dataset.open = "opened";
    this.open.textContent = "Fechar";

    const cepInput = this.form?.querySelector('[name="shipping-component"]');
    if (cepInput) {
      cepInput.value = "";
      cepInput.focus();
    }

    this.updateShippingListValue(0, true);

    // Recarregar página se estiver na URL /cart
    if (window.location.pathname === "/cart") {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  // Método para recalcular automaticamente o frete quando o carrinho muda
  autoRecalculateShipping = async () => {
    // this.log("🚀 Iniciando recálculo automático do frete...");

    // Verificar se há um CEP salvo anteriormente
    const savedCep = localStorage.getItem("lastCalculatedCep");
    if (!savedCep || savedCep.length !== 8) {
      //   this.log("❌ CEP não encontrado ou inválido:", savedCep);
      return; // Não há CEP válido salvo
    }

    // Só recalcular se não estivermos na página do carrinho (para evitar reload infinito)
    if (window.location.pathname === "/cart") {
      //   this.log("❌ Evitando recálculo na página /cart");
      return;
    }

    // this.log("✅ CEP válido encontrado:", savedCep);

    try {
      // Mostrar skeleton loading
      //   this.log("🎨 Mostrando skeleton loading...");
      this.showRecalculatingState();

      // Adicionar delay para garantir que a animação seja visível
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Simular o preenchimento do formulário e cálculo
      const cepInput = this.form?.querySelector('[name="shipping-component"]');
      if (cepInput) {
        cepInput.value = savedCep;
      }

      // Executar o cálculo automaticamente
      //   this.log("🔄 Calculando frete...");
      await this.calculateShippingRates(savedCep);

      // Adicionar delay antes de esconder para ver o resultado
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Esconder skeleton loading
      //   this.log("✅ Escondendo skeleton loading...");
      this.hideRecalculatingState();
    } catch (error) {
      //   this.log("❌ Erro ao recalcular frete automaticamente:", error);
      // Esconder skeleton loading em caso de erro
      this.hideRecalculatingState();
    }
  };

  // Métodos para controlar a animação de recálculo
  showRecalculatingState = () => {
    // this.log("🎨 showRecalculatingState chamado");
    const listBox = this.querySelector(".selected-shipping-components");
    const resume = listBox?.querySelector(".shipping-resume");

    // this.log("📦 listBox:", listBox);
    // this.log("📄 resume:", resume);

    if (resume) {
      //   this.log("✅ Adicionando classe shipping-recalculating");
      this.classList.add("shipping-recalculating");
    } else {
      //   this.log("🔧 Criando skeleton temporário");
      // Se não há frete selecionado, criar skeleton temporário
      this.createTemporarySkeleton();
    }
  };

  hideRecalculatingState = () => {
    // this.log("🎨 hideRecalculatingState chamado");
    this.classList.remove("shipping-recalculating");
    this.removeTemporarySkeleton();
  };

  createTemporarySkeleton = () => {
    // this.log("🔧 createTemporarySkeleton chamado");
    const listBox = this.querySelector(".selected-shipping-components");
    if (!listBox || listBox.querySelector(".shipping-skeleton-temp")) {
      //   this.log("❌ listBox não encontrado ou skeleton já existe");
      return;
    }

    const skeletonHtml = `
      <div class="shipping-skeleton-temp" style="padding: 10px 0;">
        <div class="shipping-skeleton wide"></div>
        <div class="shipping-skeleton medium"></div>
        <div class="shipping-skeleton narrow"></div>
      </div>
    `;

    // this.log("✅ Inserindo skeleton HTML");
    listBox.insertAdjacentHTML("beforeend", skeletonHtml);
    listBox.classList.remove("hidden");
  };

  removeTemporarySkeleton = () => {
    // this.log("🗑️ removeTemporarySkeleton chamado");
    const skeleton = this.querySelector(".shipping-skeleton-temp");
    if (skeleton) {
      //   this.log("✅ Removendo skeleton");
      skeleton.remove();
    } else {
      //   this.log("❌ Skeleton não encontrado para remover");
    }
  };

  calculateShippingRates = async (zip) => {
    try {
      // 1) PREPARE
      const prepare = await fetch("/cart/prepare_shipping_rates.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          shipping_address: {
            zip,
            country: "Brazil",
            province: "MG",
          },
        }),
      });

      if (!prepare.ok) {
        const err = await prepare.json().catch(() => ({}));
        throw new Error(
          err?.errors || "Não foi possível iniciar o cálculo de frete."
        );
      }

      // 2) POLLING (GET) até ter tarifas
      const params = new URLSearchParams({
        "shipping_address[zip]": zip,
        "shipping_address[country]": "Brazil",
        "shipping_address[province]": "MG",
      });
      const rates = await this.pollRates(`/cart/shipping_rates.json?${params}`);

      if (!rates.length) {
        // Se não há rates disponíveis, limpar seleção anterior
        localStorage.removeItem("shippingRates");
        localStorage.removeItem("selectedShippingRate");
        return;
      }

      rates.sort((a, b) => a.price - b.price);
      localStorage.setItem("shippingRates", JSON.stringify(rates));

      // Selecionar automaticamente a opção mais barata (primeira após ordenação)
      const cheapestRate = rates[0];
      localStorage.setItem(
        "selectedShippingRate",
        JSON.stringify(cheapestRate)
      );
      this.renderSelected(cheapestRate);
    } catch (error) {
      //   this.log("Erro ao calcular frete:", error);
    }
  };
}

customElements.define("cart-shipping-component", CartShipping);
